import { User, UserPreferencesCountryEnum } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';
import { AxiosError, AxiosResponse } from 'axios';
import { NewUserService } from './new-user-service';
import { UserInput } from '../models/user-input';

export class AddNewUserService extends NewUserService {
	public updateUserValues(values: UserInput): void {
		this.user = values;
	}

	public async save(): Promise<User | { error: string }> {
		if (this.user.id) {
			return this.user;
		}
		if (!this.userInputValid(this.user)) {
			return { error: 'Invalid user properties' };
		}
		try {
			const createUserResponse = ((await this.usersApi.createUser({
				data: this.user,
			})) as unknown) as AxiosResponse<{ data: User }>;
			return createUserResponse.data.data;
		} catch (e) {
			const errorResponse = ApiUtils.handleApiError(
				e as AxiosError,
				'Failed to create user: unknown error',
			);
			return { error: errorResponse.errorMessage };
		}
	}

	public cancel(): void {
		this.updateUserValues({
			email: '',
			firstName: '',
			lastName: null,
			phone: null,
			preferences: { country: UserPreferencesCountryEnum.Nz },
		});
	}
}
